function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullhorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2200 2200",
    style: {
      enableBackground: "new 0 0 2200 2200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2200,
    height: 2200
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9EEF2"
    },
    d: "M1957,933.538v280.397c0,8.802-4.054,17.117-11,22.531l-14.135,11.027l-100.619,78.511V821.469 l100.619,78.511L1946,911.007C1952.946,916.421,1957,924.736,1957,933.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C5AA8"
    },
    d: "M739.095,1541.184c66.192,2.25,132.44,2.853,198.663,1.811 c26.093-0.411,42.419-28.442,29.941-51.362c-18.893-34.703-29.376-74.018-29.679-113.543l-190.145-5.986L739.095,1541.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007CE2"
    },
    d: "M925.784,1844.186c0,12.219-4.952,23.276-12.957,31.289c-8.005,8.005-19.062,12.957-31.281,12.957 H751.297c-44.01,0-84.85-22.68-108.354-59.894c-89.637-141.903-130.838-314.28-113.322-481.335l261.849-3.77 c-45.156,151.195-23.042,352.093,117.865,466.341C919.718,1818.194,925.784,1830.821,925.784,1844.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007CE2"
    },
    d: "M406.641,1338.946h-82.372c-44.884,0-81.269-36.385-81.269-81.269V889.792 c0-44.884,36.385-81.269,81.269-81.269h82.372V1338.946z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005DCC"
    },
    d: "M424.203,921.668H310.851c-13.226,0-23.947-10.722-23.947-23.948v0 c0-13.226,10.722-23.947,23.947-23.947h113.352V921.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005DCC"
    },
    d: "M424.203,1039.011H310.851c-13.226,0-23.947-10.722-23.947-23.948v0 c0-13.226,10.722-23.948,23.947-23.948h113.352V1039.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005DCC"
    },
    d: "M424.203,1156.354H310.851c-13.226,0-23.947-10.722-23.947-23.948l0,0 c0-13.226,10.722-23.948,23.947-23.948h113.352V1156.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005DCC"
    },
    d: "M424.203,1273.697H310.851c-13.226,0-23.947-10.722-23.947-23.948v0 c0-13.226,10.722-23.947,23.947-23.947h113.352V1273.697z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9EEF2"
    },
    d: "M1711.536,1766.465c0,0-262.728-378.895-687.856-378.895V759.9 c425.128,0,687.856-378.895,687.856-378.895h33.236v1385.46H1711.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0098FF"
    },
    d: "M1780.973,1835.901L1780.973,1835.901c-38.349,0-69.436-31.088-69.436-69.436V381.005 c0-38.349,31.088-69.436,69.436-69.436h0c38.349,0,69.436,31.088,69.436,69.436v1385.46 C1850.409,1804.814,1819.321,1835.901,1780.973,1835.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0098FF"
    },
    d: "M1023.826,1419.691H474.215c-44.594,0-80.745-36.151-80.745-80.745V808.523 c0-44.594,36.151-80.745,80.745-80.745h549.611c17.74,0,32.121,14.381,32.121,32.121v627.671 C1055.948,1405.31,1041.567,1419.691,1023.826,1419.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0098FF"
    },
    d: "M1957,933.538v280.397c0,8.802-4.054,17.117-11,22.531l-14.135,11.027V899.98L1946,911.007 C1952.946,916.421,1957,924.736,1957,933.538z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn);
export default __webpack_public_path__ + "static/media/bullhorn.b009d4f80f826d5b8eca4e52f1bbfb21.svg";
export { ForwardRef as ReactComponent };